import axios from "axios";

import { SearchQuery } from "shared/data/reducers/types/storage";

import { findAndRemoveKeyFromObj } from "../../lib/functions";
import getCbtClient, { cbtResponse } from "../cbtClient";

export async function resolvePoliciesGOL({
  searchFlightsExtendedResp,
  userIds,
  travelReasonId,
  costCenterId,
  tripType,
  cbtToken,
  customerUsername,
  cbtApiUrl,
  guestsGradeIds,
}) {
  if (!cbtToken) return;

  const filteredResponse = findAndRemoveKeyFromObj(searchFlightsExtendedResp, [
    "References",
    "BrandServices",
  ]);

  const payload = {
    UserIds: userIds,
    TravelReasonId: travelReasonId,
    ...{ GuestsGradeIds: guestsGradeIds },
    CostCenterId: costCenterId,
    TripType: tripType,
    GolApiResponse: filteredResponse,
  };

  const cbtClient = await getCbtClient({
    cbtToken,
    customerUsername,
    cbtApiUrl,
  });

  return cbtResponse(cbtClient.post(`/policies/resolve-gol-api-v3`, payload));
}

export async function getPolicyResultGOL({
  policyResolvedId,
  cbtToken,
  customerUsername,
  cbtApiUrl,
}: {
  policyResolvedId: string;
  cbtToken: string;
  customerUsername: string;
  cbtApiUrl?: string;
}): Promise<{ success: boolean; data?: any; errorCode?: number }> {
  try {
    const cbtClient = await getCbtClient({
      cbtToken,
      customerUsername,
      cbtApiUrl,
    });
    const response = await cbtClient.get(
      `/policies/resolve-gol-api-v3/results/${encodeURIComponent(
        policyResolvedId
      )}`
    );
    return { success: true, data: response.data };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return { success: false, errorCode: 404 };
    }
    return cbtResponse(Promise.reject(error));
  }
}

export function getTripType(query?: Partial<SearchQuery>) {
  if (query?.flight_1_origin) return "MultiCity";
  if (query?.returnDate && query.returnDate.length > 0) return "RoundTrip";
  return "OneWay";
}
